import {
  LayoutDashboard,
  CalendarClock,
  MessageSquare,
  MessageCircle,
  Megaphone,
  GraduationCap,
  BookOpen,
  Clock,
  KeyRound,
  FileText,
  CreditCard,
  Bus,
  BarChart3,
  UserCog,
  WalletCards,
  BadgeInfo,
} from "lucide-react";

export const schoolNavData = [
  {
    category: "MANAGE",
    items: [
      {
        title: "Home",
        icon: LayoutDashboard,
        url: "/school-home",
      },
      {
        title: "School Profile",
        icon: BadgeInfo,
        url: "/school/edit",
      },
      {
        title: "Student & Classes",
        icon: GraduationCap,
        url: "/student-classes",
      },
      {
        title: "Staff",
        icon: UserCog,
        url: "/staff-hub",
      },
      {
        title: "Academics",
        icon: BookOpen,
        url: "/academics",
      },
      {
        title: "Exams & Marks",
        icon: FileText,
        url: "/exams",
      },
      {
        title: "Fee Management",
        icon: CreditCard,
        url: "/fees",
      },
      {
        title: "Payroll",
        icon: WalletCards,
        url: "/payroll",
      },
      {
        title: "Transport",
        icon: Bus,
        url: "/transport",
      },
      {
        title: "Report Cards",
        icon: FileText,
        url: "/report-cards",
      },
      {
        title: "Analytics",
        icon: BarChart3,
        url: "/analytics",
      },
    ],
  },
  {
    category: "OTHER",
    items: [
      {
        title: "Leave Requests",
        icon: CalendarClock,
        url: "/leave-management",
      },
      {
        title: "Leave Types",
        icon: Clock,
        url: "/leave-types",
      },
      {
        title: "Chat",
        icon: MessageSquare,
        url: "/chat",
      },
      {
        title: "Notification Apps",
        icon: Megaphone,
        url: "/notification-apps",
      },
    ],
  },
  {
    category: "SYSTEM",
    items: [
      {
        title: "Change Password",
        icon: KeyRound,
        url: "/change-password",
      },
    ],
  },
];

export default schoolNavData;